/** The runner value that means the cloud, as the chat's runner picker and the server use it. */
export const CLOUD_RUNNER = 'cloud';

export const RUN_SETUP_POLL_MS = 10_000;

export const RUN_SELECTION_STORAGE_KEY = 'aibuild_app_run_selection';
